import { Component } from '@angular/core';
import { DialogSize, GaMessageService, IDialog } from '../../../shared/message/ga-message.service';
import { ICompanyData } from '../../company/company-info/company-info.service';
import { CompanyDialogComponent } from '../../company/company-dialog.component';

@Component({
  selector: 'company-demo',
  template: `
    <h3>Company component dialog</h3>
    <br />

    Edit company ID:
    <p>
      <span *ngFor="let companyId of companies">
        <button class="btn btn-default" (click)="showDialog(companyId)">{{companyId}}</button> &nbsp; 
      </span>
    </p>
    <br />

    Edit custom company ID:
    <p class="row">
      <span class="col-md-2">
        <input type="number" min="0" class="form-control" [(ngModel)]="customCompanyId" (blur)="showDialog(customCompanyId)" />
      </span>
    </p>
    <br />

    <p>
      <button class="btn btn-primary" (click)="showDialog('NEW')">Add new company</button> &nbsp;
    </p>
  `
})
export class CompanyDemoComponent {
  public companies:number[] = [
    2893,
    3070,
    3071,
    3072
  ];
  public customCompanyId:number;
  private companyDialog:IDialog;

  constructor(
    private messageService:GaMessageService
  ) {
    /**/
  }

  public showDialog(companyId:string|number):void {
    if (companyId) {
      this.companyDialog = this.messageService.showDialog({
        component: CompanyDialogComponent,
        size: DialogSize.LG,
        inputs: {
          companyId
        },
        outputs: {
          onSaved: this.onSaved,
          onCancel: () => {
            this.companyDialog.hide();
          }
        },
        wrapperComponent: false
      });
    }
  }

  private onSaved = (companyData:ICompanyData):void => {
    console.log('onSaved', companyData);
    this.companyDialog.hide();
  };
}